import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPage.css';

function TeamPage() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="static-page">
      <nav className={`nav ${scrolled ? 'nav-scrolled' : ''}`}>
        <div className="nav-container">
          <a href="/" className="nav-logo" aria-label="CerebralMachines home"><img src="/CMLogo.png" alt="CerebralMachines" /></a>
          <div className="nav-links">
            <a href="/">Home</a>
            <a href="/platform">Platform</a>
            <a href="/how-it-works">How it Works</a>
            <a href="/use-cases">Use Cases</a>
            <a href="/consulting">Consulting</a>
          </div>
          <div className="nav-actions">
            <button className="btn-ghost" onClick={() => navigate('/login')}>Sign In</button>
            <button className="btn-primary" onClick={() => navigate('/request-demo')}>Request a Demo</button>
          </div>
        </div>
      </nav>

      <section className="sp-hero">
        <div className="sp-container">
          <h1 className="sp-hero-title">Our Team</h1>
          <p className="sp-hero-text">
            A world-class team of engineers, researchers, and enterprise technologists building the future of cognitive AI.
          </p>
        </div>
      </section>

      <section className="sp-section">
        <div className="sp-container">
          <h2 className="sp-section-title">Leadership</h2>
          <p className="sp-text">
            Our leadership team brings decades of combined experience in AI research, enterprise software,
            cognitive computing, and large-scale system architecture. We've built and scaled AI platforms
            at some of the world's largest technology and financial services companies.
          </p>
          <div className="sp-cards">
            <div className="sp-card">
              <h3>Engineering</h3>
              <p>
                Deep expertise in semantic computing, graph architectures, distributed systems,
                and real-time inference engines. Our engineering team builds the core cognitive
                platform that powers enterprise reasoning.
              </p>
            </div>
            <div className="sp-card">
              <h3>Research</h3>
              <p>
                Our research team advances the frontiers of probabilistic reasoning, linguistic
                cognition, and deterministic AI — translating breakthrough ideas into production-grade
                capabilities.
              </p>
            </div>
            <div className="sp-card">
              <h3>Enterprise Solutions</h3>
              <p>
                Experienced practitioners who have delivered large-scale AI programs across healthcare,
                finance, insurance, and government. They bridge the gap between technology and
                business impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="sp-section sp-section-alt">
        <div className="sp-container">
          <h2 className="sp-section-title">Our Culture</h2>
          <p className="sp-text">
            We are a team of builders who believe that enterprise AI should be deterministic, explainable,
            and trustworthy. We value intellectual rigor, customer obsession, and shipping things that
            actually work in production.
          </p>
          <p className="sp-text">
            Every person on the team contributes to our mission of making enterprise AI controllable
            and impactful. We hire people who thrive on hard problems and care deeply about quality.
          </p>
        </div>
      </section>

      <section className="sp-cta">
        <div className="sp-container">
          <h2 className="sp-cta-title">Join Our Team</h2>
          <p className="sp-cta-text">
            We're looking for exceptional talent to help us build the cognitive layer for enterprise AI.
          </p>
          <button className="btn-primary-large" onClick={() => navigate('/careers')}>View Open Positions</button>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-main">
            <div className="footer-brand">
              <a href="/" className="footer-logo" aria-label="CerebralMachines home"><img src="/CMLogo.png" alt="CerebralMachines" /></a>
              <p className="footer-tagline">Building the cognitive backbone for enterprise AI.</p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Product</h4>
                <ul>
                  <li><a href="/platform">Platform</a></li>
                  <li><a href="/how-it-works">How it Works</a></li>
                  <li><a href="/use-cases">Use Cases</a></li>
                  <li><a href="/consulting">Consulting</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="/about">About</a></li>
                  <li><a href="/team">Team</a></li>
                  <li><a href="/careers">Careers</a></li>
                  <li><a href="/contact">Contact</a></li>
                </ul>
              </div>
              <div className="footer-column">
                <h4>Legal</h4>
                <ul>
                  <li><a href="/privacy">Privacy Policy</a></li>
                  <li><a href="/terms">Terms of Service</a></li>
                  <li><a href="/security">Security</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 CerebralMachines. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default TeamPage;
